<template>
  <div>

    <p class="h4">Dateien anschauen oder hochladen</p>

    <form class="form-horizontal mb-8 max-w-2xl" @submit.prevent="upload(files[0])">

      <!-- file input -->
      <div class="form-group">
        <label class="form-label col-3 col-sm-12" for="files">Datei</label>
        <input id="files" ref="files"
               accept="image/jpeg,image/png,video/mp4,video/x-matroska,image/webp,image/gif,audio/mp3"
               class="form-input col-9 col-sm-12" required type="file" @change="files = $event.target.files">
      </div>

      <!-- filename input -->
      <div class="form-group">
        <label class="form-label col-3 col-sm-12" for="filename">Dateinamen</label>
        <input id="filename" v-model="name" class="form-input col-9 col-sm-12" placeholder="Dateinamen" required
               type="text">
      </div>

      <!-- button -->
      <div class="form-group">
        <div class="col-3 col-sm-12" />
        <button :class="{'loading' : uploading, 'disabled' : !files || !name || !name.length}"
                class="btn col-9 col-sm-12">
          Hochladen
        </button>
      </div>
    </form>

    <div class="divider text-center"></div>

    <div v-if="filteredMediaFiles == null" class="loading"/>

    <div class="grid mt-8 gap-4 grid-cols-5">
      <media-card v-for="object in filteredMediaFiles" v-if="filteredMediaFiles != null" :object="object"
                  @delete="filteredMediaFiles.remove(object)"/>
    </div>

  </div>
</template>

<script>
import { globalMediaFilesCollection, storage } from "../../plugins/firebase";
import MediaCard from "./MediaCard";
import { v4 as uuidv4 } from 'uuid';
import firebase from "firebase/app";
import { filteredMediaFiles } from "@/store/media";

export default {
  name: "Mediathek",
  components: { MediaCard },
  data() {
    return {
      files: null,
      uploading: null,
      name: null,
    }
  },
  methods: {
    async upload(file) {
      this.uploading = true;

      const path = `media/${uuidv4()}-${this.name}`;
      const ref = storage.ref(path);
      const task = await ref.put(file);

      await globalMediaFilesCollection.doc(this.$store.state.user.uid).update({
        files: firebase.firestore.FieldValue.arrayUnion({
          path: path,
        })
      });

      this.uploading = false;
      this.filteredMediaFiles.push({
        ref: task.ref,
        url: await ref.getDownloadURL(),
        meta: await ref.getMetadata(),
        name: task.ref.name.substr(37)
      });

      // reset form
      this.name = "";
      this.$refs.files.value = "";
      this.files = null;
    }
  },
  computed: { filteredMediaFiles }
};
</script>
<style>
.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
}
</style>